import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { AbstractPickedFile, TemplatePickedFile } from 'app/models/picked-file';
import { FieldsPickerComponent } from 'app/views/fields-picker/fields-picker.component';
import { FormTemplate } from 'app/models/template';
import { FormTemplateService } from 'app/services/form-template.service';
import { finalize, distinctUntilChanged, pairwise } from 'rxjs/operators';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { WorkflowForm } from 'app/models/workflow-form';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-add-edit-workflow-form',
  templateUrl: './add-edit-workflow-form.component.html',
  styleUrls: ['./add-edit-workflow-form.component.scss']
})
export class AddEditWorkflowFormComponent implements OnInit {

  @Output() addEditAccepted: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  forExecution: boolean;
  isEdit: boolean;
  @Input() parentsForms: WorkflowForm[] = [];
  @Input() enableDuplicateFormOption: boolean = false;

  workflowFormToAddFormGroup: FormGroup;
  
  @ViewChild('addEditFormModal', { static: true }) addEditFormModal: ModalDirective;
  @ViewChild('fieldsPicker', { static: true }) fieldsPicker: FieldsPickerComponent;
  
  cachedForm: FormTemplate;
  isLoadingForm: boolean = false;
  selectedParentForm: WorkflowForm = null;
  isExistingValueChangeSubscription: Subscription = null;

  fieldsPropertyName: string = 'required_fields';

  constructor(private formTemplateService: FormTemplateService, private validationHandler: ValidationHandler) { }

  ngOnInit(): void {
    this.cachedForm = null;
    this.isLoadingForm = false;
    this.selectedParentForm = null;
  }

  show(frm: FormGroup, isEdit: boolean = false, forExecution: boolean = false) {
    this.isEdit = isEdit;
    this.forExecution = forExecution;
    
    this.workflowFormToAddFormGroup = frm;
    if (this.parentsForms.length == 0) {
      frm.get('is_existing').setValue(0);
    } else {
      
      this.subscribeToisExistingChanges();

      if (this.isEdit && frm.get('is_existing').value) {
        this.selectedParentForm = this.parentsForms[this.parentsForms.findIndex((f) => f.name == frm.get('name').value)];
        this.onExistingFormChange(this.selectedParentForm);
      } else {
        this.selectedParentForm = null;
      }
    }

    this.addEditFormModal.show();
  }

  subscribeToisExistingChanges() {
    this. isExistingValueChangeSubscription = this.workflowFormToAddFormGroup.get('is_existing').valueChanges.subscribe((newValue) => {
      if (newValue == 0) {
        this.workflowFormToAddFormGroup.get('name').reset();
        this.workflowFormToAddFormGroup.get('form_template_id').reset();
        this.workflowFormToAddFormGroup.get('form_template').reset();
      } else if (newValue == 1) {
        this.selectedParentForm = this.parentsForms[0];
        this.onExistingFormChange(this.selectedParentForm);
      }
    });
  }

  onExistingFormChange(newWorkflowForm: WorkflowForm) {
    this.workflowFormToAddFormGroup.get('name').setValue(newWorkflowForm.name);
    this.workflowFormToAddFormGroup.get('form_template_id').setValue(newWorkflowForm.form_template_id);
    this.workflowFormToAddFormGroup.get('form_template').setValue(newWorkflowForm.form_template);
  }

  onAddWorkflowFormClick() {
    if (this.isExistingValueChangeSubscription) {
      this.isExistingValueChangeSubscription.unsubscribe();
      this.isExistingValueChangeSubscription = null;
    }

    this.validationHandler.onSubmitCheck(this.workflowFormToAddFormGroup);
    if(!this.workflowFormToAddFormGroup.valid){
      this.subscribeToisExistingChanges();
      return;
    }  

    this.addEditAccepted.emit(this.workflowFormToAddFormGroup);
    this.addEditFormModal.hide();
  }

  onPickedTemplate(e: AbstractPickedFile[]) {
    let pickedTemplate = e[0] as TemplatePickedFile;
    this.workflowFormToAddFormGroup.controls['form_template_id'].setValue(pickedTemplate.id);
    this.workflowFormToAddFormGroup.get('form_template').setValue(pickedTemplate);
  }

  onPickFields(fieldsPropertyName: string) {
    this.fieldsPropertyName = fieldsPropertyName;
    if (this.cachedForm && this.cachedForm.id == this.workflowFormToAddFormGroup.value.form_template_id) {
      this.fieldsPicker.showPicker(this.cachedForm.schema, this.workflowFormToAddFormGroup.value[fieldsPropertyName]);
    } else {
      this.isLoadingForm = true;
      this.formTemplateService.getById(this.workflowFormToAddFormGroup.value.form_template_id).pipe(finalize(()=>{
        this.isLoadingForm = false;
        /** @todo handle errors */
      })).subscribe((f)=>{
        this.cachedForm = f;
        this.fieldsPicker.showPicker(this.cachedForm.schema, this.workflowFormToAddFormGroup.value[fieldsPropertyName] || []);
      });
    }
  }

  onFinishedPicking(fields: string[]) {
    this.workflowFormToAddFormGroup.controls[this.fieldsPropertyName].setValue(fields);
  }
}
